import { Component, OnInit, inject } from '@angular/core';
import { PageComponent } from 'src/app/components/pages/page.component';
import { APPLICATION_ROUTES } from 'src/app/constants/application-routes';
import { AdobePageName } from 'src/app/services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from 'src/app/services/adobe-launch/adobe-launch.service';
import { TitleService } from 'src/app/services/title/title.service';
import { environment } from 'src/environments/environment';

import { ContentUtil } from '../../../../../utils/content/content.util';
import { InterstitialPageContentComponent } from '../../../../../components/interstitial-page-content/interstitial-page-content.component';

@Component({
    selector: 'zci-add-users-page',
    templateUrl: './add-users-page.component.html',
    styleUrls: ['./add-users-page.component.scss'],
    imports: [InterstitialPageContentComponent],
})
export class AddUsersPageComponent extends PageComponent implements OnInit {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private titleService = inject(TitleService);

    content = ContentUtil.content;

    appRoutes = APPLICATION_ROUTES;

    environment = environment;

    ngOnInit(): void {
        this.titleService.setTitle(this.content.accountInterstitialPages.addUser.pageTitle);
        this.adobeLaunchService.pageLoad(
            AdobePageName.OWN_ACCOUNTS_ADD_AUTHORIZED_USERS_PAGE_INTERSTITIAL,
        );
    }
}
